import React from "react";
import { withGoogleMap, GoogleMap } from "react-google-maps";
import Marker from "react-google-maps/lib/components/Marker";

function GMap({ location, zoom }) {
  return (
    <GoogleMap defaultZoom={zoom} defaultCenter={location} center={location}>
      <Marker position={location} />
    </GoogleMap>
  );
}

export default withGoogleMap(GMap);
